export default {
  isLoggedIn: false,
  member: null,
  errorMessage: null,
  isSidebarVisible: false,
  prevPath: '',
};
